<template>
  <div
    :class="{
      switchTab: variant === 'horizontal',
    }"
  >
    <ul
      :class="{
        switchTab: variant === 'vertical',
      }"
    >
      <div v-for="(tab, index) in tabList" :key="index" :class="'tab'+index" class="split" @click='carouselfunc' >
        <label :class="'label'+index+activeStatus " :for="`${_uid}${index}`" v-text="tab"  />
        <input
        
        @click="ToggleValue()"
          :id="`${_uid}${index}`"
          type="radio"
          :name="`${_uid}-tab`"
          :value="index + 1"
          v-model="activeTab"
          style="display:none"
        />
      </div>
    </ul>

    <template v-for="(tab, index) in tabList">
      <div :key="index" v-show="index + 1 === activeTab">
        <slot :name="`tabPanel-${index + 1}`" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: () => "vertical",
      validator: (value) => ["horizontal", "vertical"].includes(value),
    },
  },
  data() {
    return {
      activeStatus: false,
      activeTab: 1,
    };
  },
  methods: {
    ToggleValue(){
      if(this.activeStatus == false){
        this.activeStatus = true;
      }else{
        this.activeStatus = false;
      }
    },
    carouselfunc(){
        document.dispatchEvent(new CustomEvent("renderProductPagination"));
    }
  }
};
</script>

<style lang='scss' scoped>
.switchTab {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0;
  padding: 0;
  background: #FFFFFF;

  label{
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .label0false {
    background-color: #FFFFFF;
    color: #025CB9;
  }

  .label1false {
    background-color: #00468C;
    color: #FFFFFF;
  }

  .label1true {
    background-color: #FFFFFF;
    color: #025CB9;
  }

  .label0true {
    background-color: #00468C;
    color: #FFFFFF;
  }

  .split{
      font-size: 18px;
      justify-content: center;
      align-items: center;
      letter-spacing: 0;
      display: flex;
      font-weight: 500;
      font-family: 'trim-medium';
      @media screen and (max-width: 450px) {
          font-size: 13px;
      }
  }

}

</style>